// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"9564e025","297":"bb9a5737","424":"82ba307f","455":"062dbbc3","470":"0e7f7f52","673":"67e9c138","741":"7db35e93","816":"bbc7fb01","859":"0084bb83","976":"1b45ac5c"}[chunkId] + ".chunk.js";
};